import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import Moment from "moment";
import history from "../../history";
import { default as BASE } from "../../config";
import { v1 as uuid } from "uuid";
import { setBookingItem } from "../../actions";
import { Button } from "react-bootstrap";
import AvailabilitySearchForm from "./AvailabilitySearchForm";
import Parser from "html-react-parser";
import veraApi from "../../apis/veraApi";
import _ from "lodash";
import { loader } from "../../helpers";

const AvailabilitySearchContainer = ({ deal, setSoldOut }) => {
  //  const { image, path, title, code } = props;
  const [fromDates, setFromDates] = useState([]);
  const [toDates, setToDates] = useState([]);
  const [allowedDates, setAllowedDates] = useState([]);
  const [loading, setLoading] = useState(true);
  let traveDatesarr = [];
  let fromDatesarr = [];
  let toDatesarr = [];

  const dispatch = useDispatch();

  useEffect(() => {
    deal && fetchOptionInfo();
  }, [deal]);

  const availabilityForm = (formValues) => {
    const title = deal.field_vc_deal_title
      ? deal.field_vc_deal_title
      : deal.title;

    let bookingItem = {
      itemNo: uuid(),
      dateTime: new Date(),
      title: title,
      nights: deal.field_vc_total_nights,
      packageId: deal.nid,
      campaignId: deal.nid_1,
      optCode: deal.field_au_tourplan_option_code,
      totAdults: formValues.noAdult,
      totChildren: formValues.noChild,
      totPrice: formValues.totalPrice,
      giftCard: false,
      dateFrom: Moment(formValues.travelDates.startDate).format("YYYY-MM-DD"),
      dateTo: Moment(formValues.travelDates.endDate).format("YYYY-MM-DD"),
      //path: `${BASE.CONFIG.BASEURL}${history.location.pathname}`,
      path: `${history.location.pathname}`,
    };

    dispatch(setBookingItem(bookingItem));
    history.push("/booking");
  };

  const fetchOptionInfo = async () => {
    traveDatesarr = deal.field_valid_for_travel.split(",");
    //console.log(traveDatesarr);
    traveDatesarr.forEach(function (object) {
      fromDatesarr.push(
        Moment(object.split("-")[0].trim()).format("YYYY-MM-DD")
      );
      toDatesarr.push(Moment(object.split("-")[1].trim()).format("YYYY-MM-DD"));
    });

    //console.log(traveDatesarr);

    setFromDates(fromDatesarr);
    setToDates(toDatesarr);

    const res = await veraApi
      .post("search/getOptionMultiAvail", {
        providers: ["tp"],
        agent: "VIVB2C",
        password: "lovethatvivafeeling",
        opts: [deal.field_au_tourplan_option_code],
        multiDateFrom: fromDatesarr,
        multiDateTo: toDatesarr,
      })
      .catch((error) => {
        //todo show booking unavailable
        console.log(error);
      });

    let results = null;
    results = res && res.data.Response.results;

    let availability = _.map(results, (avail) => {
      return avail.availability;
    });

    if (_.isObject(results) && availability) {
      setAvailableDates(fromDatesarr, toDatesarr, availability);
    }

    setLoading(false);

    //res && console.log(res.data.Response.results);
  };

  const setAvailableDates = (travelFrom, travelTo, availNight) => {
    let rangeCount = travelFrom.length;
    let rangeAvail = availNight.length;
    //console.log(rangeCount, rangeAvail);
    //let dates = [];
    let datesObj = [];

    _.map(_.range(rangeAvail), (id) => {
      let start = Moment(travelFrom[id], "YYYY-MM-DD");
      let end = Moment(travelTo[id], "YYYY-MM-DD").add(1, "days");

      let availability = null;
      availability = availNight[id] && availNight[id];
      //console.log(availability, availNight, id);

      let current = start.clone();
      let result = [];
      let count = 0;

      while (current.isBefore(end)) {
        //-1 allows for checkout on a blocked date

        let trueAvailability = availability[count];
        let roomsAvail = trueAvailability;

        if (count > 0) {
          roomsAvail = availability[count - 1];
          if (
            trueAvailability < 1 &&
            availability[count - 1] > 0 &&
            availability[count + 1] > 0
          ) {
            roomsAvail = trueAvailability;
          }
        }

        if (
          Moment(current.format("YYYY-MM-DD")).isAfter() &&
          (roomsAvail > 0 || trueAvailability > 0)
        ) {
          //result.push(current.format("YYYY-MM-DD"));
          datesObj.push({
            date: current.format("YYYY-MM-DD"),
            dateRange: id,
          });
        }
        count++;
        current.add(1, "day");
      }
      //dates = [...dates, ...result];
    });

    //console.log(_.map(allowedDates, "date"));
    setAllowedDates(datesObj);
    //setAllowedDates(dates);
  };

  if (!_.isEmpty(allowedDates)) {
    return (
      <div className="col-md-12 order-md-2 mb-4">
        {/* <h4 className="d-flex justify-content-between align-items-center">
        <span className="sidebar-heading">Check Availability</span>
      </h4> */}
        {/* <hr className="mb-4 mt-0" /> */}

        <AvailabilitySearchForm
          currentpackage={deal}
          fromDates={fromDates}
          toDates={toDates}
          allowedDates={allowedDates}
          availabilityForm={availabilityForm}
        />

        <div className="conditions mt-4 mb-4">
          {/* <h6>Important Booking Conditions</h6> */}
          {/* <p><small>{Parser(this.props.currentPackage.field_terms_conditions)}</small></p> */}
        </div>
      </div>
    );
  } else if (loading) {
    return <div className="col-md-12 order-md-2 mb-4">{loader()}</div>;
  } else {
    setSoldOut(true);
    return <></>;
  }
};

export default AvailabilitySearchContainer;
